import { TextField, Typography } from '@arionbanki/arionui';
import { Footer, ProgressBar } from 'components';
import { type Member, useSigningAuthority } from './useSigningAuthority';

export function SigningAuthority() {
	const { data, errors, members, goBack, submit, t, validate } = useSigningAuthority();
	return (
		<ProgressBar page="signing-authority">
			<Typography className="mb-4" TagName="h3">
				{t('signing_authority_main_title')}
			</Typography>
			<Typography className="mb-4" TagName="p">
				{t('signing_authority_main_text')}
			</Typography>
			<Typography className="mb-4" TagName="p">
				{t('signing_authority')} {data && <b>{data.signingAuthority}</b>}
			</Typography>
			<form className="row mb-4">
				{members?.map((row: Member) => (
					<div className="col-6 p-3" key={row.ssn}>
						<div className="bg-light">
							<div className="p-4 card-input">
								<Typography className="mb-1" TagName="h6">
									{row.name}
								</Typography>
								<p>{row.roles}</p>
								<TextField
									error={!!errors[row.ssn]}
									label={t('email')}
									message={t(errors[row.ssn])}
									name={row.ssn}
									onChange={validate}
								/>
							</div>
						</div>
					</div>
				))}
			</form>
			<Footer
				handleNext={submit}
				handlePrev={goBack}
				isDisabled={false}
				next={t('continue')}
				prev={t('back')}
			/>
		</ProgressBar>
	);
}
